/* eslint-disable */
import * as Types from './types';

export type WidgetPlaceholderFragment = { __typename?: 'WidgetPlaceholder', widget?: string | null, config?: object | null };

export declare const WidgetPlaceholderFragment: import("graphql").DocumentNode;
export const WidgetPlaceholderFragmentDoc = /*#__PURE__*/ `
    fragment WidgetPlaceholderFragment on WidgetPlaceholder {
  widget
  config
}
    `;